import axios from 'axios'

type ApiErrorLike = {
  code?: string
  name?: string
  message?: string
  response?: { status?: number }
  config?: { signal?: AbortSignal; timeout?: number }
}

/** React Query / navigation abort — axios peut remonter "Network Error" à tort. */
export function isRequestCancellation(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false

  const err = error as ApiErrorLike

  if (typeof axios.isCancel === 'function' && axios.isCancel(error)) {
    return true
  }

  if (err.code === 'ERR_CANCELED') return true
  if (err.name === 'CanceledError' || err.name === 'AbortError') return true
  if (err.config?.signal?.aborted === true) return true

  const message = typeof err.message === 'string' ? err.message.toLowerCase() : ''
  if (message === 'canceled' || message === 'cancelled') return true

  return false
}

/** Vraie coupure client↔serveur (pas timeout applicatif, pas annulation). */
export function isTransientNetworkError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false
  if (isRequestCancellation(error)) return false

  const err = error as ApiErrorLike

  if (err.code === 'ECONNABORTED' || err.message?.includes('timeout')) {
    return false
  }

  if (err.response?.status) {
    return false
  }

  if (
    err.code === 'ERR_NETWORK' ||
    err.message === 'Network Error' ||
    err.name === 'NetworkError'
  ) {
    return true
  }

  if (err.code === 'ECONNREFUSED' || err.code === 'ENOTFOUND') {
    return true
  }

  if (err.code === 'ETIMEDOUT' && !err.config?.timeout) {
    return true
  }

  if (err.message?.includes('fetch failed') || err.message?.includes('getaddrinfo')) {
    return true
  }

  return false
}
